module.exports = __webpack_public_path__ + "media/assets/icons/alert-6910f7ff49167cf81d48ab2a3695b729.svg";